import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard } from './shared';

const UUIDGenerator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [uuids, setUuids] = useState<string[]>([]);
  const [count, setCount] = useState('1');

  const generate = () => {
    const n = parseInt(count) || 1;
    const newUuids = Array.from({ length: Math.min(n, 100) }, () =>
      'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      })
    );
    setUuids(newUuids);
    onResultChange(newUuids.map((u, i) => ({ label: `UUID ${i + 1}`, value: u })));
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <FormField label="Quantidade" value={count} onChange={setCount} isInteger required />
          <div className="flex items-center pt-6">
            <button onClick={generate} className="px-10 py-3 bg-accent-gradient text-white rounded-xl font-bold flex items-center gap-2"><Icon name="refresh" className="w-5 h-5" /> Gerar</button>
          </div>
        </div>
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {uuids.map((u, i) => (
            <div key={i} className="p-3 bg-theme-input rounded-lg font-mono text-sm border border-theme-border flex justify-between items-center">
              {u}
              <button onClick={() => navigator.clipboard.writeText(u)} className="text-xs text-indigo-600 font-bold">Copiar</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UUIDGenerator;
